<template>
    <div class="login-warpper">
        <loginModular>
            <slot slot="login">
                <div class="login-title flex align-center justify-around">
                    <span class="active">忘记密码</span>
                </div>
                <el-form :model="loginForm" :rules="rules" ref="loginForm" class="margin-top-sm ">
                    <el-form-item prop="account">
                        <el-input
                            placeholder="请输入帐号/企业全称"
                            v-model="loginForm.account">
                            <i slot="prefix" class="iconfont icon-yonghu "></i>
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="phone">
                        <el-input
                            placeholder="请输入手机号"
                            v-model="loginForm.phone">
                            <i slot="prefix" class="iconfont icon-shouji "></i>
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="code">
                        <div class="form-item">
                            <el-input
                                placeholder="请输入验证码"
                                maxlength="6"
                                v-model="loginForm.code">
                                <i slot="prefix" class="iconfont icon-verify font-size"></i>
                            </el-input>
                            <span class="forget" @click="checkCode">{{ codeText }}<i
                                v-if="typeof codeText === 'number'">秒</i></span>
                        </div>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input
                            placeholder="请设置密码"
                            type="password"
                            v-model="loginForm.password">
                            <i slot="prefix" class="iconfont  icon-mima font-size"></i>
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="replayPassword">
                        <el-input
                            placeholder="请确认密码"
                            type="password"
                            v-model="loginForm.replayPassword">
                            <i slot="prefix" class="iconfont  icon-mima font-size"></i>
                        </el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button class="login-btn" @click="submitForm('loginForm')">立即修改</el-button>
                    </el-form-item>
                </el-form>
                <router-link to="/login" class="to-login">
                    <span>返回登录</span>
                </router-link>
            </slot>
        </loginModular>
        <div class="footer">
            版权所有©2017-2022 北京消防协会  <span class="padding-lr"></span> 京公网安备11010502040396号 <a href="">京ICP备15022697号-1</a>
        </div>
    </div>
</template>

<script>
import loginModular from '@/components/login-modular'
import {foget,  sendCode} from "@/api/login";
import util from "@/utils/rules";

export default {
    name: "forger",
    data() {
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else {
                if (this.loginForm.replayPassword !== '') {
                    this.$refs.loginForm.validateField('replayPassword');
                }
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.loginForm.password) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            loginForm: {
                account: '',
                phone: '',
                password: '',
                replayPassword: '',
                code: ''
            },
            rules: {
                account: [{required: true, message: '请输入企业全称', trigger: 'blur'}],
                phone: util.phone,
                password: [{validator: validatePass, trigger: 'blur'}],
                replayPassword: [{validator: validatePass2, trigger: 'blur'}],
                code: [{required: true, message: '请输入验证码', trigger: 'blur'}],
            },
            codeText: '发送验证码', // 验证码文字
            id: null, // 计时器id
            timeId: null, // 一次性计时器id
        }
    },
    components: {
        loginModular
    },
    created() {
    },
    methods: {
        //  提交注册信息
        async toRegister() {
            const loading = this.$loading({
                lock: true,
                text: '登录中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let _data = await foget(this.loginForm.account, this.loginForm.phone, this.loginForm.code, this.loginForm.password, this.loginForm.replayPassword)
            loading.close();
            this.$message.success('恭喜您，修改成功！')
            console.log(_data)
            await this.$router.replace('/login')
        },
        //  验证注册信息
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.toRegister()
                }
            });
        },
        //  获取手机验证码
        checkCode() {
            this.$refs.loginForm.validateField('phone', (valid) => {
                if (!valid) {
                    // 发送ajax
                    if (this.codeText === '发送验证码' || this.codeText === '重新发送') {
                        this.sendCode()
                    }
                }
            })
        },
        //  发送验证码
        async sendCode() {
            let _data = await sendCode(this.loginForm.phone,3)
            if (_data.status === 200) {
                this.codeText = 60
                this.id = setInterval(() => {
                    if (this.codeText === 0) {
                        this.codeText = '重新发送'
                        return
                    }
                    if (typeof this.codeText === 'number') {
                        this.codeText--
                    }
                }, 1000)
            }
        }
    }
}
</script>

<style scoped lang="scss">
.login-warpper{
    padding-bottom: 60px;}
.login-title {
    padding: 0 40px;

    span {
        display: block;
        font-size: 18px;
        line-height: 36px;
        cursor: pointer;

        &.active {
            color: #0d7fd7;
            border-bottom: 3px solid #0d7fd7;
        }
    }

    i {
        display: block;
        width: 1px;
        height: 18px;
        background: #ccc;
    }

}

.form-item {
    position: relative;
}

.form-item .forget {
    position: absolute;
    top: 2px;
    right: 2px;
    display: block;
    height: 36px;
    width: 101px;
    line-height: 38px;
    color: #0d7fd7;
    text-align: center;
    background: #fff;
    cursor: pointer;
}

.color-style {
    display: block;
    width: 60px;
    text-align: center;
    color: #0d7fd7;
    font-size: 18px;
    letter-spacing: 3px;
    cursor: pointer;
}

.login-btn {
    display: block;
    width: 100%;
    height: 40px;
    background-color: #f60000;
    border-radius: 4px;
    border: 0;
    font-size: 18px;
    color: #fff;
    cursor: pointer;
}

.to-login {
    display: block;
    width: 100px;
    text-align: center;
    color: #999;
    margin: -8px auto 0;
}
.footer{
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 60px;
    line-height: 60px;
    background: #333;
    color: #fff;
    text-align: center;
    a{
        color: #fff;
    }
}
</style>